export const INCOME_STATEMENT_REQUESTED = 'INCOME_STATEMENT_REQUESTED';
export const INCOME_STATEMENT_SUCCESS = 'INCOME_STATEMENT_SUCCESS';
export const INCOME_STATEMENT_FAILED = 'INCOME_STATEMENT_FAILED';
